/* created by CoolGuy on 2018/11/28 */
import React from 'react';
import Notification from './Notification';
import { observer, inject } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import moment from 'moment';

@inject('rootStore')
@observer
class CountDownNotification extends React.Component {
  constructor(props) {
    super(props);
    this.setTime(props.time);
  }

  @observable time = 0;
  @action setTime = time => {
    this.time = time;
  };

  @computed get hms() {
    const { time } = this;
    if (time > 0) {
      const duration = moment.duration(time);
      const h = duration.get('h');
      const m = duration.get('m');
      const s = duration.get('s');
      return [h < 10 ? '0' + h : h, m < 10 ? '0' + m : m, s < 10 ? '0' + s : s];
    } else {
      return ['00', '00', '00'];
    }
  }

  timer = null;

  onClose = () => {
    this.props.rootStore.redPackStore.setNotification(false);
  };

  onClick = () => {
    const { redPackStore } = this.props.rootStore;
    // 为了让弹框能够显示出来
    redPackStore.setLocalLastForShowTime(null, null);
    redPackStore.getServerTime().then(timestamp => {
      redPackStore.getDetail().then(() => {
        redPackStore.setLocalLastForShowTime(null, timestamp);
      });
    });
  };

  setCountDownTimer = () => {
    let now = new Date().getTime();
    this.timer = setInterval(() => {
      const thisMoment = new Date().getTime();
      const delta = thisMoment - now;
      // console.log(delta);
      now = thisMoment;
      this.setTime(this.time - delta);
      // 注意时间可能是小于1秒的，最终会是负数或者0
      if (this.time <= 0) {
        clearInterval(this.timer);
        const { redPackStore } = this.props.rootStore;
        // 倒计时为0之后强制将notification关闭
        // 否则因为notification会被重新渲染（因为重新获取了服务器时间等），然后notification会使用上次进入时的值，导致了异常
        redPackStore.setNotification(false);
        redPackStore.getServerTime().then(() => {
          redPackStore.getDetail();
        });
      }
    }, 500); // 没过一段时间就去处理一次，精度误差不会超过这个数字，理论上小于1000都可以
  };

  componentDidMount() {
    this.setCountDownTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { hms } = this;
    const [h, m, s] = hms;
    const { onClose, onClick } = this;

    return (
      <Notification h={h} m={m} s={s} onClose={onClose} onClick={onClick} />
    );
  }
}
export default CountDownNotification;
